module.exports = __webpack_public_path__ + "static/media/parts.7.da541e52.png";